import { render, staticRenderFns } from "./PensionCalcFormWidget.vue?vue&type=template&id=6421b014&scoped=true"
import script from "./PensionCalcFormWidget.vue?vue&type=script&lang=js"
export * from "./PensionCalcFormWidget.vue?vue&type=script&lang=js"
import style0 from "./PensionCalcFormWidget.vue?vue&type=style&index=0&id=6421b014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6421b014",
  null
  
)

/* custom blocks */
import block0 from "./PensionCalcFormWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports